import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS} from "../consts";
import {OddsToggleClickEvent} from "../models/events/odds-toggle-click-event";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";

export class ToggleShowOddsHandler extends AnalyticsEventHandler {
  localStorageUtils: LocalStorageUtils;
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.toggleShowOdds;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils, AnalyticsService];

  constructor(localStorageUtils: LocalStorageUtils, analyticsService: AnalyticsService) {
    super(analyticsService);

    this.localStorageUtils = localStorageUtils;
    this.analyticsService = analyticsService;

    this.eventType = OddsToggleClickEvent;
  }

  action(params) {
    const showOdds: Boolean = params?.setManually ? params.oddsVisible : !this.appStore.state.showOdds;

    this.appStore.setShowOdds(showOdds);
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.showOdds, showOdds);

    if (showOdds) {
      this.appStore.setShowSecondaryOdds(showOdds);
      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.showSecondaryOdds, showOdds);
    }

    if (!params?.disableAnalytics) {
      super.action(params)
    }
  }
}
